// La sidebar en la tira (sólo el logo) desde que se eligen los productos: la pantalla que
// pregunta, la conversación y el catálogo
// (ADR-2026-10-14-el-catalogo-conversa-a-pantalla-completa-hasta-armar), como el Agente y Redes
// (ADR-2026-09-16-el-lienzo-achica-la-sidebar-a-una-tira). En un layout effect: al pasar de la
// pregunta a la conversación una se desmonta y la otra se monta en el mismo commit, y así la
// tira no se apaga ni un frame en el medio.
import { useLayoutEffect } from 'react';
import { ANCHO_LOGO_SIDEBAR_MINIMA, useSidebar } from '../../../../context/SidebarContext';
import { useDebajoDeMd } from '../../../../hooks/useEsMobile';

/** Prende la tira mientras `activa`; devuelve cuánto correr lo que va arriba a la izquierda para
 *  que no quede debajo del logo. */
export function useTiraDeSidebar(pedida: boolean): number {
  const { setSidebarMinima, pedirColapsarSidebar, sidebarMinima } = useSidebar();
  // En el teléfono no hay tira: el contexto del shell de teléfono no la apaga solo (eso lo hace
  // el de escritorio cuando no hay ancho) y la pantalla se corría el ancho del logo a la derecha
  // (ADR-2026-10-15-el-catalogo-en-el-telefono-4).
  const esTelefono = useDebajoDeMd();
  const activa = pedida && !esTelefono;
  useLayoutEffect(() => {
    if (!activa) return;
    setSidebarMinima(true);
    pedirColapsarSidebar();
    return () => setSidebarMinima(false);
  }, [activa, setSidebarMinima, pedirColapsarSidebar]);
  return activa && sidebarMinima ? ANCHO_LOGO_SIDEBAR_MINIMA : 0;
}
